<template>
    <div>
      <span class="testResult__resultRow__text">
        <span
          :class="[overallResult === 0 ? 'testResult__resultRow__text__redIcon' :
          overallResult === 1 ? 'yellow-icon' : 'green-icon'  ]"
        >
          <font-awesome-icon
            :icon="['fas', overallResult === 0 ? 'times-circle' : 'check-circle']"
          />
        </span>
        <span class="diagnosis_text">
          {{
          overallResult === 0 ? $t('testResult.diagnosisBad') :
          overallResult === 1 ? $t('testResult.diagnosisAverage')
          : $t('testResult.diagnosisGood')
          }}
        </span>
      </span>
    </div>
</template>

<script>
    export default {
        name: "GeneralDiagnosis",
        props: {
          overallResult: {
            require: true
          }
        }
    }
</script>

<style scoped>
  svg {
    margin-right: 15px;
  }
  .diagnosis_text {
    font-size: 1rem;
    font-weight: 400;
  }
  .red-icon {
    color: #ff0000;
  }
  .green-icon {
    color: #0dcb09;
  }
  .yellow-icon {
    color: #fe9c55;
  }
</style>
